import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import './style.scss';

export const FreeDaubNotificationDot = observer((props: { type?: 'small' | 'normal' }) => {
  const { bingoStore } = useStores();
  const hasUnusedFreeDaub =
    bingoStore.freeDaubBalance && bingoStore.freeDaubBalance.balance > 0 && !bingoStore.hasFreeDaubApplied;

  if (!hasUnusedFreeDaub) return null;

  return (
    <div className={`notification-dot ${props.type || ''}`}>
      <div className="dot"></div>
    </div>
  );
});
